import {
  http
} from '../config';
import base from './base';

export const myProfile={
  getNotBasePayroll(time){
    return http({
      url:`${base.users}/tea/payroll/${time}`,
      method:'get',
    });
  },
  getBasePayroll(time,monthType){
    return http({
      url:`${base.users}/tea/payroll/${time}/${monthType}`,
      method:'get'
    });
  },
  getMemberPayroll(time){
    return http({
      url:`${base.users}/tea/memberShip/payroll/${time}`,
      method:'get',
    });
  },
  modifyProfile(data){
    return http({
      url:`${base.users}/tea/modifyProfile`,
      method:'post',
      data,
    });
  },
  getProfileDetail(){
    return http({
      url:`${base.users}/tea/profileDetails`,
      method:'get',
    });
  },
  getProfileVideo(){
    return http({
      url:`${base.users}/tea/videoIntroductionDetails`,
      method:'get',
    });
  },
  putProfileVideo(data){
    return http({
      url:`${base.users}/tea/modifyVideoIntroduction`,
      method:'post',
      data
    });
  },
  getMoreInfoDetail(){
    return http({
      url:`${base.users}/tea/moreInformationDetails`,
      method:'get',
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/myProfile.js